import React from 'react'

import {
  Template,
  TemplatePlaceholder,
  Plugin,
  TemplateConnector
} from '@devexpress/dx-react-core'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

export default function SelectionAction(props) {
  const { onClick, tooltip, text } = props

  return (
    <Plugin name="SelectionAction">
      <Template name="toolbarContent">
        <TemplatePlaceholder />
        <TemplateConnector>
          {() => (
            <Tooltip title={tooltip} placement="bottom" enterDelay={300}>
              <Button
                style={{ margin: '0 16px' }}
                color="primary"
                variant="outlined"
                onClick={onClick}>
                {text}
              </Button>
            </Tooltip>
          )}
        </TemplateConnector>
      </Template>
    </Plugin>
  )
}
